import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import ContactForm from "../components/CotactForm";

const contactInfoData = [
  {
    id: 1,
    icon: "las la-envelope",
    title: "Email orqali",
    desc: "velvetstore@gmail.com",
  },
  {
    id: 2,
    icon: "las la-phone-volume",
    title: "Qo'ng'iroq qiling",
    desc: "+998 99 632 70 70",
  },
  {
    id: 3,
    icon: "las la-map",
    title: "Tashrif buyuring",
    desc: "Abu Saxiy A68-do'kon, Toshkent, O'zbekiston",
  },
];

const Contact = () => {
  return (
    <section className="sp-tb" id="contact">
      <Container>
        <Row>
          <Col lg={6}>
            {/* - Section Heading - */}
            <div className="section-heading mb-5">
              <div className="sub-heading">
                <p>Biz bilan bog'laning</p>
              </div>
              <div className="heading-title">
                <h2>Aloqaga chiqing</h2>
              </div>
              <div className="heading-description">
                <p>Savollaringiz bo'lsa, biz bilan bog'laning - sizga yordam berishdan mamnun bo'lamiz.</p>
              </div>
            </div>
            {/* - Section Heading - */}

            {/* - Contact Info - */}
            <div className="contact-infos mt-5">
              {(contactInfoData || []).map((info) => (
                <div className="iconbox-secondary mb-4" key={info.id}>
                  <div className="item-icon me-4">
                    <i className={info.icon}></i>
                  </div>
                  <div className="item-content">
                    <h4>{info.title}</h4>
                    <p>{info.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            {/* - Contact Info - */}
          </Col>
          <Col lg={6}>
            {/* - Contact Form - */}
            <ContactForm />
            {/* - Contact Form - */}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;
